import { defineComponent } from 'vue'
import type { PropType, ExtractPropTypes } from 'vue'


export const querytableColumnLinkProps = () => ({
  head: String,
  headAlign: String as PropType<'left' | 'right' | 'center'>,
  bodyAlign: String as PropType<'left' | 'right' | 'center'>,
  name: String,
  width: [String, Number],
  fixed: [Boolean, String],
})

export type QuerytableColumnLinkProps = Partial<ExtractPropTypes<ReturnType<typeof querytableColumnLinkProps>>>

export default defineComponent({
  name: 'OQuerytableColumnLink',
  inheritAttrs: false,
  props: querytableColumnLinkProps(),
  setup(props, { slots, attrs, emit, expose }) {
    return () => null
  },
})
